import { resolve as urlResolve } from 'url';
import { getPackageBaseUrl } from 'owa-config';

export default function resolveFREImage(imageName: string): string {
    return urlResolve(getPackageBaseUrl(), `resources/images/refresh-fre/${imageName}`);
}
